import React from "react";
import ReactDom from "react-dom";
import { Navigation, Link } from "react-router";
import Api from "js/utilities/fnapi-client";
import { ZOOM_ICON } from "js/config.jsx";
import { getQueryString } from "js/utilities/get-query-string";
import UserHandler from "js/utilities/user-handler";
import Amplitude from "js/utilities/amplitude";
import Loader from "react-loader";

export default React.createClass({
  mixins: [Navigation],

  statics: {
    includeHeaderFooter: false
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState: function() {
    var tokenId = "?key=";
    return {
      error: null,
      loding: false,
      authToken : getQueryString(tokenId)
    };
  },

  render: function() {
    return (
      <div className="bg">
        <div className="signin">
          <div className="box">
            <div className="header">
              <img src={ZOOM_ICON} className="img"/>
              <p className="title">developer account</p>
            </div>
            <p className="sub-title">password reset</p>
            <form autoComplete="off" onSubmit={this.handleSubmitPassword}>
              <input id="input-password" ref="newPassword" placeholder="new password" type="password" required />
              <br/><br/>
              <div className="password-button">
                <button type="submit"><a id="fontstack">{!this.state.loading ? "enter" : <Loader loaded={this.state.loaded} lines={12} length={2.5} width={2.5} radius={10} corners={1} rotate={0} direction={1} speed={1.75} trail={80} shadow={false} hwaccel={true} className="spinner" zIndex={2e9} top="50%" left="50%" scale={.8}></Loader> }</a></button>
              </div>
              <p className="loginerror">{this.state.error}</p>
            </form>
          </div>
        </div>
      </div>
    );
  },

  handleSubmitPassword: function(event) {
    event.preventDefault();
    this.setState({error: ""});
    var pwdData = {
      password: this.refs.newPassword.value
    };
    if (this.state.authToken) {
        pwdData.authToken = this.state.authToken;
        this.resetPassword(pwdData);
    }
    else {
      this.setPassword(pwdData);
    }
  },

  resetPassword: function(pwdData) {
    Api.post("user/password/reset",pwdData).then( (response) => {
      var text = "Your password has been updated!";
      if (UserHandler.loggedIn()){
        this.context.router.push("/docs");
        Amplitude.send("signin-success-pwd");
      }
      //This shouldn't ever happen
      else {
        return this.context.router.push("/signin");
      }
    }).catch( (error) => {
      this.setState({error: error.message});
    });
  },

  setPassword: function(pwdData) {
    Api.post("user/current",pwdData).then( (response) => {
      var text = "Your password has been updated!";
      if (UserHandler.loggedIn()) {
        return this.context.router.push("/docs");
      }
      else {
        return this.context.router.push("/signin");
      }
    }).catch( (error) => {
      this.setState({error: error.message});
    });
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/reset-password.jsx